import styles from './BusinessResourceGrid.scss';

import React from 'react';

import Slider from 'react-slick';
import { InternalLinkV2 } from 'src/components/ContentLinkV2/InternalLinkV2';
import { Grid } from 'src/components/Grid/Grid';
import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useMobile } from 'src/hooks/UseResponsive';
import { AppType, WithCMS } from 'src/services/cms/typesUtil';
import { componentKey } from 'src/utils/EntryUtil';

type BusinessResourceGridProps = AppType.Component<{
  headline: string;
  items: Array<WithCMS<AppType.Content>>;
}>;

export const BusinessResourceGrid: React.FC<BusinessResourceGridProps> = ({
  headline,
  items,
  ...props
}) => {
  const isMobile = useMobile();
  const config = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    cssEase: 'ease',
    variableWidth: true,
  };
  const cardList = items?.map((item, index) => businessGridCard(item, index));

  return (
    <Grid container className={styles.container} {...props} {...props._attributes} justifyContent="center">
      <Grid item xs={12} md={10} lg={8}>
        {headline && (
          <TextV2
            hasId
            variant="h2-bold"
            tagName="h2"
            className={styles.containerTitle}
            value={headline}
          />
        )}
      </Grid>
      {items && (
        <Grid container>
          {isMobile && (
            <Slider {...config} className={styles.containerProductSlider}>
              {cardList}
            </Slider>
          )}
          {!isMobile && cardList}
      </Grid>
      )}
    </Grid>
  );
};

const businessGridCard = (item: any, index: number): JSX.Element => {
  const { image, title, blurb, link } = item || {};
  return (
    <Grid item xs={12} lg={6} key={componentKey(item, index)} className={styles.containerCardGridStyle}>
      <div className={styles.containerCard}>
        <div>
          <Image src={image?.file?.url} className={styles.containerCardImage} />
        </div>
        <div className={styles.containerCardDetails}>
          <TextV2
            hasId
            variant="h5-medium"
            tagName="h5"
            value={title}
            className={styles.containerCardDetailsTitle}
          />
          <TextV2 variant="body" tagName="div" value={blurb} />
          <InternalLinkV2 entry={link} className={styles.containerCardDetailsLink} />
        </div>
      </div>
    </Grid>
  );
};

BusinessResourceGrid.displayName = 'BusinessResourceGrid';
